import React, {useEffect, useState} from "react";
import axios from "axios";
import Swal from "sweetalert2";
import {Button, Card, Col, Form, Modal, Row} from "react-bootstrap";
import ERPDataGrid from "../ERPDataGrid";
import "../ERPTheme.css";
import {baseUrl, ipAddress, userName,} from "../Univ";
const KPI = () => {
    const [kpis, setKpis] = useState([]);
    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [kpiId, setKpiId] = useState(null);
    const initialState = {
        kpi_name: "",
        kpi_category: "",
        target_value: "",
        actual_value: "",
        unit: "",
        period: "",
        status: "Active",
        is_active: true
    };
    const [formData, setFormData] = useState(initialState);
// ============================
// LOAD KPI
// ============================
    const loadKPI = async () => {
        try {
            setLoading(true);
            const res = await axios.get(baseUrl + "kpi/");
            setKpis(res.data);
        } catch (error) {
            Swal.fire("Error",
                "Unable to load KPI",
                "error");
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        loadKPI();
    }, []);
// ============================
// CHANGE
// ============================
    const handleChange = (e) => {
        const {
            name,
            value,
            type,
            checked
        } = e.target;
        setFormData({
            ...formData,
            [name]:
                type === "checkbox"
                    ?
                    checked
                    :
                    value
        });
    };
// ============================
// SAVE
// ============================
    const saveKPI = async () => {
        try {
            if (editMode) {
                await axios.put(baseUrl + `kpi/${kpiId}/`,
                    formData);
            } else {
                await axios.post(baseUrl + "kpi/",
                    formData);
            }
            Swal.fire("Success",
                "KPI Saved Successfully",
                "success");
            setShow(false);
            resetForm();
            loadKPI();
        } catch (error) {
            Swal.fire("Error",
                "Unable to save KPI",
                "error");
        }
    };
// ============================
// EDIT
// ============================
    const editKPI = (row) => {
        setEditMode(true);
        setKpiId(row.id);
        setFormData(row);
        setShow(true);
    };
// ============================
// DELETE
// ============================
    const deleteKPI = (id) => {
        Swal.fire({
            title: "Delete KPI?",
            icon: "warning",
            showCancelButton: true
        })
            .then(async (result) => {
                if (result.isConfirmed) {
                    await axios.delete(`kpi/${id}/`);
                    loadKPI();
                }
            });
    };
    const resetForm = () => {
        setFormData(initialState);
        setEditMode(false);
        setKpiId(null);
    };
// ============================
// DASHBOARD
// ============================
    const total = kpis.length;
    const achieved =
        kpis.filter(x =>
            Number(x.actual_value)
            >=
            Number(x.target_value)).length;
    const pending =
        total - achieved;
    const columns = [
        {
            field: "id",
            headerName: "ID",
            width: 80
        },
        {
            field: "kpi_name",
            headerName: "KPI Name",
            flex: 1
        },
        {
            field: "kpi_category",
            headerName: "Category",
            flex: 1
        },
        {
            field: "target_value",
            headerName: "Target",
            width: 120
        },
        {
            field: "actual_value",
            headerName: "Actual",
            width: 120
        },
        {
            field: "unit",
            headerName: "Unit",
            width: 100
        },
        {
            field: "period",
            headerName: "Period",
            width: 120
        },
        {
            field: "status",
            headerName: "Status",
            width: 120
        },
        {
            field: "action",
            headerName: "Action",
            width: 200,
            renderCell: (params) => (
                <>

                    <Button

                        size="sm"

                        variant="warning"

                        className="me-2"

                        onClick={() => editKPI(params.row)}

                    >

                        Edit

                    </Button>


                    <Button

                        size="sm"

                        variant="danger"

                        onClick={() => deleteKPI(params.row.id)}

                    >

                        Delete

                    </Button>


                </>
            )
        }
    ];
    return (
        <>

            <Row className="mb-3">


                <Col md={4}>

                    <Card className="shadow">

                        <Card.Body>

                            <h6>

                                Total KPI

                            </h6>


                            <h2>

                                {total}

                            </h2>

                        </Card.Body>


                    </Card>

                </Col>


                <Col md={4}>

                    <Card className="shadow">

                        <Card.Body>

                            <h6>

                                Achieved

                            </h6>


                            <h2>

                                {achieved}

                            </h2>

                        </Card.Body>


                    </Card>

                </Col>


                <Col md={4}>

                    <Card className="shadow">

                        <Card.Body>

                            <h6>

                                Pending

                            </h6>


                            <h2>

                                {pending}

                            </h2>

                        </Card.Body>


                    </Card>

                </Col>


            </Row>


            <Card className="shadow">


                <Card.Header>


                    <Row>

                        <Col>

                            <h5>

                                KPI Management Dashboard

                            </h5>

                        </Col>


                        <Col className="text-end">


                            <Button

                                onClick={() => {
                                    resetForm();
                                    setShow(true);
                                }}

                            >

                                + Add KPI

                            </Button>


                        </Col>


                    </Row>


                </Card.Header>


                <Card.Body>


                    <div

                        style={{
                            height: 500
                        }}

                    >


                        <ERPDataGrid


                            rows={kpis}


                            columns={columns}


                            loading={loading}


                        />


                    </div>


                </Card.Body>


            </Card>


            <Modal

                show={show}

                onHide={() => setShow(false)}

                size="lg"

            >


                <Modal.Header closeButton>


                    <Modal.Title>


                        {
                            editMode
                                ?
                                "Edit KPI"
                                :
                                "Add KPI"
                        }


                    </Modal.Title>


                </Modal.Header>


                <Modal.Body>


                    <Form>


                        <Row>


                            <Col md={6}>


                                <Form.Label>

                                    KPI Name

                                </Form.Label>


                                <Form.Control

                                    name="kpi_name"

                                    value={formData.kpi_name}

                                    onChange={handleChange}

                                />


                            </Col>


                            <Col md={6}>


                                <Form.Label>

                                    Category

                                </Form.Label>


                                <Form.Control

                                    name="kpi_category"

                                    value={formData.kpi_category}

                                    onChange={handleChange}

                                />


                            </Col>


                        </Row>


                        <Row className="mt-3">


                            <Col md={6}>


                                <Form.Label>

                                    Target

                                </Form.Label>


                                <Form.Control

                                    type="number"

                                    name="target_value"

                                    value={formData.target_value}

                                    onChange={handleChange}

                                />


                            </Col>


                            <Col md={6}>


                                <Form.Label>

                                    Actual

                                </Form.Label>


                                <Form.Control

                                    type="number"

                                    name="actual_value"

                                    value={formData.actual_value}

                                    onChange={handleChange}

                                />


                            </Col>


                        </Row>


                        <Row className="mt-3">


                            <Col md={6}>


                                <Form.Label>

                                    Unit

                                </Form.Label>


                                <Form.Control

                                    name="unit"

                                    value={formData.unit}

                                    onChange={handleChange}

                                />


                            </Col>


                            <Col md={6}>


                                <Form.Label>

                                    Period

                                </Form.Label>


                                <Form.Control

                                    name="period"

                                    value={formData.period}

                                    onChange={handleChange}

                                />


                            </Col>


                        </Row>


                        <Form.Check

                            className="mt-3"

                            type="checkbox"

                            label="Active"

                            name="is_active"

                            checked={formData.is_active}

                            onChange={handleChange}

                        />


                    </Form>


                </Modal.Body>


                <Modal.Footer>


                    <Button

                        variant="secondary"

                        onClick={() => setShow(false)}

                    >

                        Close

                    </Button>


                    <Button

                        variant="success"

                        onClick={saveKPI}

                    >

                        Save

                    </Button>


                </Modal.Footer>


            </Modal>


        </>
    );
};
export default KPI;